import { formatMicros } from '@studio/shared';

import { useI18n } from './i18n';

/**
 * Provider costs, in the language the interface is set to.
 *
 * In dollars, because that is the currency the providers bill your keys in —
 * converting it here would mean inventing an exchange rate and presenting a
 * guess as a figure.
 */
export function useMoney() {
  const { locale } = useI18n();
  /*
   * en-US rather than en-GB for money alone: British English writes a US dollar
   * as "US$0.36", which is correct and reads as noise on a line that is only
   * ever dollars. French keeps "$US", which is how French writes it.
   */
  const tag = locale === 'fr' ? 'fr-FR' : 'en-US';

  return {
    /** What something cost to make, from micro-dollars. */
    cost: (micros: number, fractionDigits = 2) => formatMicros(micros, 'usd', tag, fractionDigits),
  };
}
